import { RouteSettingBoard } from '../components/route-setting-board/RouteSettingBoard';

/** The boulders half of the route-setting kanban. */
export default function BouldersBoardPage() {
  return <RouteSettingBoard climbType="boulder" />;
}
